module.exports = __webpack_public_path__ + "img/tatargurkenrollfront.c2621600.png";